import { writable } from "svelte/store"

type StatsStore = {
  yourEntries: number
  totalEntries: number | string
  isEnded: boolean
  timeLeft: string
  isLoading: boolean
}

const createStatsStore = () => {
  const { subscribe, set, update } = writable<StatsStore>({
    yourEntries: 0,
    totalEntries: 0,
    isEnded: false,
    timeLeft: "",
    isLoading: true,
  })

  return {
    subscribe,
    setStats: (stats: Partial<StatsStore>) =>
      update((store) => ({ ...store, ...stats })),
    reset: () =>
      set({
        yourEntries: 0,
        totalEntries: 0,
        isEnded: false,
        timeLeft: "",
        isLoading: true,
      }),
  }
}

export const statsStore = createStatsStore()
export const statsStoreActions = {
  setStats: (stats: Partial<StatsStore>) => statsStore.setStats(stats),
  reset: () => statsStore.reset(),
}
